@if ({
  tables: tables$ | async,
  currentTable: currentTable$ | async,
  }; as content) {
  @if (content.tables?.length) {
    <div class="tab-container">
      <div class="tabs">
        @for (table of content.tables; track table) {
          <div class="tab" [ngClass]="{ active: content.currentTable === table.uid }">
            <button (click)="setTab(table.uid)">{{ table.title }}</button>
          </div>
        }
      </div>
      <div class="content">
        @for (table of content.tables; track table) {
          <div class="tab" [ngClass]="{ active: content.currentTable === table.uid }">
            @if (identifyTable(table) === TABLE_SPEC_TYPE.MULTI_COLUMN) {
              <generic-table-multi-collumns [table]="table"></generic-table-multi-collumns>
            }
            @if (identifyTable(table) === TABLE_SPEC_TYPE.DOUBLE_ATTRS) {
              <generic-table-double-attrs [table]="table"></generic-table-double-attrs>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <p class="text-center m-0">{{ 'productSpecifications.noContent' | cxTranslate }}</p>
  }
}